<template>
  <transition name="fade">
    <div ref="modal" class="modal d-block show" tabindex="-1" role="dialog">
      <div :class="getModalDialogClasses" role="document">
        <div class="modal-content">
          <slot></slot>
        </div>
      </div>
      <div class="modal-backdrop show"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    large: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getModalDialogClasses() {
      return {
        'modal-dialog': true,
        'modal-dialog-centered': true,
        'modal-lg': this.large,
      };
    },
  },
};
</script>
